import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '../components/Box'
import Breadcrumb from '../components/Breadcrumb'
import Color from '../components/Color'
import ManageTable from '../components/ManageTable'
import { TableHeaderDataProps } from '../components/Table'
import { fetchBrand } from '../fetchers/fetcher'
import { errorCallback } from '../helpers/errorCallback'
import { errorMessage } from '../helpers/errorMessage'
import useAlert from '../hooks/useAlert'
import useLogin from '../hooks/useLogin'
import {DeleteIcon, EditIcon} from '../icons/icon'
import { IBrand } from '../types/types'




const breadCrumbItems = [
    { name: "Brand Maintenance", active: true },
]

let defaultHeader: TableHeaderDataProps[] = [
    { key: "b_id", name: "ID", width: "4%", sort: "unsort" },
    { key: "date_time", name: "Date", width: "6%", sort: "unsort" },
    { key: "brand", name: "Brand", sort: "unsort" },
    { key: "status", name: "Status", align: "center", width: "5%" },
    { key: "action", name: "Action", align: "center", width: "5%" },
]



const BrandList = () => {
    let history = useNavigate()
    const {token, setToken} = useLogin()
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [reload, setReload] = useState(false)

    const {setAlert} = useAlert()

    const handleDelete = useCallback((_data: IBrand) => {
        setAlert({
            show: true,
            message: "Delete " + _data.brand + " ?",
            type: "question",
            cb: async () => {
                try {
                    let result = await axios.delete("/brand/" + _data.b_id)
        
                    if(result.status !== 200) {
                        setAlert({
                            show: true,
                            message: result.data.message,
                            type: "danger"
                        })
                    }
        
                    return setAlert({
                        show: true,
                        message: _data.brand + " Deleted Successfully !!!",
                        type: "success",
                        cb: () => {
                            setData(v => v.filter(row => row.b_id !== _data.b_id))
                        }
                    })
                } catch (err: any) {
                    console.log(err.message)
                    setAlert({
                        show: true,
                        type: "danger",
                        message: err.message
                    })
                }
            }
        })
    }, [setAlert])

    const fetchData = useCallback(async () => {
        try {
            setLoading(true)
            let _data = await fetchBrand(token)

            if(Array.isArray(_data)) {
                setData(_data.map(row => ({ 
                    ...row,
                    status: <Color color={row.status === "active" ? "green" : "red"}>{row.status}</Color>,
                    action: <Box alignItems='center' justifyContent='center'>
                        <EditIcon iconcolor="blue" iconsize='h6' onClick={() => history("/brand/" + row.b_id)} />
                        <DeleteIcon iconcolor="red" iconsize='h6' onClick={() => handleDelete(row)} />
                    </Box>
                })))
                setLoading(false)
            }
        } catch (err: any) {
            console.log(err.message)
            setLoading(false)
            setAlert({
                show: true,
                message: err.message,
                type: "danger",
                ok: errorMessage(err.message),
                cb: () => errorCallback(err.message, setReload, reload, setToken)
            })
        }
    }, [token, history, setAlert, setToken, reload, handleDelete])



    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <>
            <Breadcrumb items={breadCrumbItems} 
            button={[
                {
                    name: "New",
                    action: "/brand/new",
                    color: "blue"
                }
            ]} 
            />
            <ManageTable 
            defaultHeader={defaultHeader}
            columnSetting="brandList"
            data={data}
            filterKey={["brand"]}
            loading={loading}
            />
        </>
    )
}

export default BrandList